/**
 * @fileoverview SWR Provider Component
 * 
 * Wraps the application with SWRConfig to provide global SWR settings.
 * Should be used at the root of the application (e.g., in layout.js).
 * 
 * @module components/providers/SWRProvider
 * 
 * @example
 * // In layout.js
 * import { SWRProvider } from '@/components/providers/SWRProvider';
 * 
 * export default function RootLayout({ children }) {
 *   return (
 *     <html>
 *       <body>
 *         <SWRProvider>
 *           {children}
 *         </SWRProvider>
 *       </body>
 *     </html>
 *   );
 * }
 */
import { SWRConfig } from 'swr';
import { swrConfig } from '@/hooks/swr';

/**
 * SWR Provider component that wraps the app with global SWR configuration
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @returns {React.ReactElement} SWRConfig wrapped children
 */
export function SWRProvider({ children }) {
  return (
    <SWRConfig value={swrConfig}>
      {children}
    </SWRConfig>
  );
}

export default SWRProvider;
